import { render, staticRenderFns } from "./AssetsInput.vue?vue&type=template&id=5a9710e9&"
import script from "./AssetsInput.vue?vue&type=script&lang=js&"
export * from "./AssetsInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports